module.exports = __webpack_public_path__ + "static/media/code.1c78cfca.jpeg";